export default __webpack_public_path__ + "static/media/plug-disconnected.4a2159cc.svg";